import * as React from 'react';
import { st, classes } from './CoreLinearProgressBar.st.css';
import { ProgressBarDataHooks, ProgressBarDataKeys, ProgressBarAriaKeys, } from './DataHooks';
import { filterDataProps } from '../../utils/FilterDataProps';
const FULL_PROGRESS = 100;
const NO_PROGRESS = 0;
const resolveIndicationElement = (props) => {
    const wrapped = (dataHook, children) => (React.createElement("div", { "data-hook": dataHook, className: classes.indicationContainer }, children));
    if (props.error && props.errorIcon) {
        return wrapped(ProgressBarDataHooks.errorIcon, props.errorIcon);
    }
    if (props.value === FULL_PROGRESS && props.successIcon) {
        return wrapped(ProgressBarDataHooks.successIcon, props.successIcon);
    }
    if (props.customSuffixIndicationText) {
        return wrapped(ProgressBarDataHooks.suffixIndicator, React.createElement("span", { className: classes.suffixIndication }, props.customSuffixIndicationText));
    }
    return wrapped(ProgressBarDataHooks.progressPercentage, React.createElement("span", { className: classes.progressPercentage }, `${props.value}%`));
};
const renderBarSection = (value, isButton = false) => {
    const progressWidth = { width: `${value}%` };
    const Component = isButton ? 'button' : 'div';
    return (React.createElement(Component, { "data-hook": ProgressBarDataHooks.container, className: classes.barContainer },
        React.createElement("div", { "data-hook": ProgressBarDataHooks.background, className: classes.barBackground }),
        React.createElement("div", { "data-hook": ProgressBarDataHooks.foreground, style: progressWidth, className: classes.barForeground })));
};
const getRelativeValue = (props) => {
    const { value, min, max, precision } = props;
    const relativeValue = ((+value - min) / (max - min)) * 100;
    return precision
        ? +relativeValue.toFixed(precision)
        : parseInt(relativeValue, 10);
};
const normalizeProps = (props) => {
    if (+props.value >= props.max) {
        return { ...props, value: FULL_PROGRESS };
    }
    if (+props.value < props.min ||
        [undefined, null, ''].includes(props.value)) {
        return { ...props, value: NO_PROGRESS };
    }
    return { ...props, value: getRelativeValue(props) };
};
const getDataAttributes = (props) => {
    return {
        [ProgressBarDataKeys.value]: props.value,
        [ProgressBarDataKeys.min]: props.min,
        [ProgressBarDataKeys.max]: props.max,
    };
};
const getAriaAttributes = (props) => {
    return {
        [ProgressBarAriaKeys.valuenow]: +props.value || NO_PROGRESS,
        [ProgressBarAriaKeys.valuemin]: +props.min,
        [ProgressBarAriaKeys.valuemax]: +props.max,
        [ProgressBarAriaKeys.valuetext]: props[ProgressBarAriaKeys.valuetext],
    };
};
export const CoreLinearProgressBar = (props) => {
    const { error, showProgressIndication, prefixIndication, className, onClick, role, } = props;
    const _props = normalizeProps(props);
    const success = _props.value === FULL_PROGRESS;
    return (React.createElement("div", { ...getDataAttributes(_props), ...(role === 'progressbar' ? getAriaAttributes(props) : {}), "data-min": _props.min, "data-error": error, ...(role ? { role } : {}), className: st(classes.root, { error, success }, className), ...filterDataProps(props), onClick: onClick, "aria-label": props['aria-label'], "data-hook": props['data-hook'] ?? ProgressBarDataHooks.mainWrapper },
        prefixIndication && (React.createElement("div", { "data-hook": ProgressBarDataHooks.prefixIndicator, className: classes.prefixIndicationContainer, "aria-hidden": props['aria-hide-affixes'] }, prefixIndication)),
        renderBarSection(_props.value, !!onClick),
        showProgressIndication && (React.createElement("div", { "data-hook": ProgressBarDataHooks.progressIndicator, className: classes.progressIndicationSection, "aria-hidden": props['aria-hide-affixes'] }, resolveIndicationElement(_props)))));
};
CoreLinearProgressBar.displayName = 'CoreLinearProgressBar';
CoreLinearProgressBar.defaultProps = {
    min: NO_PROGRESS,
    max: FULL_PROGRESS,
    role: 'progressbar',
};
//# sourceMappingURL=CoreLinearProgressBar.js.map